import script from "./condimentsAppearance.vue?vue&type=script&setup=true&lang=ts"
export * from "./condimentsAppearance.vue?vue&type=script&setup=true&lang=ts"

import "./condimentsAppearance.vue?vue&type=style&index=0&id=0641684e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0641684e"]])

export default __exports__